import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import api, { formatPrice } from "../lib/api";

const STATUS_LABEL = {
  pending: "Pendiente",
  processing: "Procesando",
  shipped: "Enviado",
  delivered: "Entregado",
  cancelled: "Cancelado",
};

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/me").then(r => setOrders(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="account-page" className="pt-28 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <p className="overline mb-3">Mi cuenta</p>
        <h1 className="font-heading text-5xl text-ivory font-light tracking-tighter mb-12">Bonjour, {user?.name}</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <aside className="bg-graphite border border-smoke p-8">
            <p className="overline mb-3">Información</p>
            <p className="text-ivory mb-1">{user?.name}</p>
            <p className="text-ivory/60 text-sm">{user?.email}</p>
            <p className="text-xs text-ivory/40 mt-4 uppercase tracking-wider">Cliente desde 2026</p>
          </aside>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-2xl text-ivory mb-6">Mis pedidos</h2>
            {orders.length === 0 ? (
              <div className="bg-graphite border border-smoke p-12 text-center">
                <p className="overline mb-3">Sin pedidos</p>
                <p className="font-heading text-2xl text-ivory">Aún no ha realizado ningún pedido</p>
              </div>
            ) : (
              <div className="space-y-4">
                {orders.map(o => (
                  <div key={o.id} className="bg-graphite border border-smoke p-6" data-testid={`order-${o.id}`}>
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <p className="text-xs text-ivory/40 uppercase tracking-wider">Pedido #{o.id.slice(0, 8).toUpperCase()}</p>
                        <p className="text-ivory mt-1">{new Date(o.created_at).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })}</p>
                      </div>
                      <span className={`text-xs uppercase tracking-[0.2em] px-3 py-1 border ${o.status === "delivered" ? "border-gold text-gold" : "border-smoke text-ivory/70"}`}>
                        {STATUS_LABEL[o.status] || o.status}
                      </span>
                    </div>
                    <div className="flex gap-3 mb-4 overflow-x-auto">
                      {o.items.map((it, i) => (
                        <div key={i} className="w-14 h-16 flex-shrink-0 bg-smoke">
                          {it.image && <img src={it.image} alt="" className="w-full h-full object-cover" />}
                        </div>
                      ))}
                    </div>
                    <div className="flex justify-between items-baseline pt-4 border-t border-smoke">
                      <span className="text-ivory/60 text-sm">{o.items.length} producto(s)</span>
                      <span className="font-heading text-2xl text-gold">{formatPrice(o.total)}</span>
                    </div>
                    {o.tracking_number && (
                      <p className="text-xs text-ivory/60 mt-3">Tracking {o.carrier}: <span className="text-gold">{o.tracking_number}</span></p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
